import { Component, OnInit } from '@angular/core';

import { registerLocaleData } from '@angular/common';
import de from '@angular/common/locales/de';

import {MarketingStatisticsService} from "../../services/marketing-statistics.service";
import {FormControl, FormGroup} from "@angular/forms";
import {MatTableDataSource} from "@angular/material/table";
import * as moment from "moment";
import {Company} from "../../dto/company";
import {CompanyService} from "../services/company.service";
import {MarketingStatsFilter} from "../../dto/marketingStatsFilter";
import {Product} from "../../dto/product";
import {ProductService} from "../services/product.service";
import {RoleService} from "../../services/role.service";
import {Country} from "../../dto/country";
import {OrderService} from "../../order-assistant/services/order.service";
import {OrdersService} from "../services/orders.service";
import {CountryService} from "../../services";
import * as d3 from 'd3';
import {FinancialTotals, MarketingTotals} from "../../dto/GeoIp/city-info";
import {FinancialStatisticsService} from "../../services/financial-statistics.service";

@Component({
  selector: 'app-financial-statistics',
  templateUrl: './financial-statistics.component.html',
  styleUrls: ['./financial-statistics.component.css']
})
export class FinancialStatisticsComponent implements OnInit {

  data: Data[] = [];
  chartOrdersData: any[] = []; // Populate this with the formatted data from step 1
  chartLoadsData: any[] = []; // Populate this with the formatted data from step 1
  chartLoadsVolumeData: any[] = []; // Populate this with the formatted data from step 1
  xAxisLabel: string = "Date";
  yAxisLabel: string = "Value";
  colorScheme = {
    domain: [
      "#0077B6", "#5F9EA0", "#4682B4", "#6495ED", "#00BFFF", "#1E90FF", "#ADD8E6", "#87CEEB",
      "#87CEFA", "#191970", "#000080", "#4169E1", "#8A2BE2", "#4B0082", "#483D8B", "#6A5ACD",
      "#7B68EE", "#9370DB", "#8B008B", "#9400D3", "#9932CC", "#BA55D3", "#800080", "#D8BFD8",
      "#DDA0DD", "#EE82EE", "#FF00FF", "#DA70D6", "#C71585", "#DB7093", "#FF1493", "#FF69B4",
      "#FF4500", "#DE3163", "#FF7F50", "#FFD700", "#BDB76B", "#F0E68C", "#ADFF2F", "#7FFF00",
      "#7CFC00", "#00FF7F", "#00FA9A", "#00FFFF", "#E0FFFF", "#AFEEEE", "#40E0D0", "#48D1CC",
    ]
  };

  colorScheme2 = {
    domain: [
      "#008000", "#006400", "#228B22", "#00FF00", "#32CD32", "#90EE90", "#98FB98", "#8FBC8F",
      "#66CDAA", "#3CB371", "#20B2AA", "#2E8B57", "#F0E68C", "#BDB76B", "#DAA520", "#B8860B",
      "#CD853F", "#D2691E", "#8B4513", "#A0522D", "#A52A2A", "#800000",
      "#00CED1", "#20B2AA", "#5F9EA0", "#B0E0E6", "#B0C4DE", "#ADD8E6", "#87CEFA", "#778899",


    ]
  };
  colorScheme3 = {
    domain: [
      "#7B68EE", "#9370DB", "#8B008B", "#9400D3", "#9932CC", "#BA55D3", "#800080", "#D8BFD8",
      "#DDA0DD", "#EE82EE", "#FF00FF", "#DA70D6", "#C71585", "#DB7093", "#FF1493", "#FF69B4",
      "#CD853F", "#D2691E", "#8B4513", "#A0522D", "#A52A2A", "#800000",
      "#00CED1", "#20B2AA", "#5F9EA0", "#B0E0E6", "#B0C4DE", "#ADD8E6", "#87CEFA", "#778899",
      "#008000", "#006400", "#228B22", "#00FF00", "#32CD32", "#90EE90", "#98FB98", "#8FBC8F",
      "#66CDAA", "#3CB371", "#20B2AA", "#2E8B57", "#F0E68C", "#BDB76B", "#DAA520", "#B8860B",


    ]
  };


  financialStatsForm: FormGroup;
  isLoadingOrders = false;
  isLoadingLoads = false;
  isLoadingTotals = false;
  gradient = false;

  filters = new MarketingStatsFilter();
  products: Product[];
  selectedProducts: Product[] = [];
  selectedCompanies: Company[] = [];
  selectedCountries: Country[] = [];
  selectedPlatform: number = -1;
  countries: Country[] = [];
  totals: FinancialTotals|null;

  constructor(
    private financialStatisticsService: FinancialStatisticsService,
    private companiesService: CompanyService,
    private productService: ProductService,
    private roleService: RoleService,
    private countryService: CountryService,
  ) {
    this.initializeDates();

    this.companiesService.getAll().subscribe(value => this.companies = value.data);
    this.countryService.getManyEuFirst().subscribe(value => this.countries = value.data);
  }

  currentUserIsPartner(): boolean {
    return this.roleService.hasRoles(["partner", "partner_support"]);
  }


  initializeDates() {
    const firstDayLastMonth = moment().subtract(1, "months").startOf("month").toDate();
    const lastDayLastMonth = moment().subtract(1, "months").endOf("month").toDate();

    this.financialStatsForm = new FormGroup({
      startDate: new FormControl(firstDayLastMonth),
      endDate: new FormControl(lastDayLastMonth),
      grouping: new FormControl(4),
      interval: new FormControl(1),
    });
  }

  goToPreviousPeriod() {
    let start = moment(this.financialStatsForm.get("startDate").value);
    let end = moment(this.financialStatsForm.get("endDate").value);

    // Check if the period is a full month
    if (start.date() === 1 && end.date() === moment(end).endOf("month").date()) {
      start.subtract(1, "month").startOf("month");
      end.subtract(1, "month").endOf("month");
    } else {
      let duration = moment.duration(end.diff(start));
      start.subtract(duration);
      end.subtract(duration);
    }

    this.financialStatsForm.setValue({
      startDate: start.toDate(),
      endDate: end.toDate(),
      grouping: this.financialStatsForm.get("grouping").value,
      interval: this.financialStatsForm.get("interval").value,
    });

    this.submit();

  }

  companyChanged() {
    this.products = [];

    this.fetchProducts();

  }

  fetchProducts() {
    if (this.selectedCompanies.length > 0) {


      this.productService.getForCompanies(this.selectedCompanies.map(value => value.id)).subscribe(c => {
        this.products = c;
      });
    } else {
      this.productService.getAll().subscribe(value => this.products = value.data);
    }
  }


  goToNextPeriod() {
    let start = moment(this.financialStatsForm.get("startDate").value);
    let end = moment(this.financialStatsForm.get("endDate").value);

    // Check if the period is a full month
    if (start.date() === 1 && end.date() === moment(end).endOf("month").date()) {
      start.add(1, "month").startOf("month");
      end.add(1, "month").endOf("month");
    } else {
      let duration = moment.duration(end.diff(start));
      start.add(duration);
      end.add(duration);
    }

    this.financialStatsForm.setValue({
      startDate: start.toDate(),
      endDate: end.toDate(),
      grouping: this.financialStatsForm.get("grouping").value,
      interval: this.financialStatsForm.get("interval").value
    });


    this.submit();

  }

  submit() {

    this.createSvg();

    const {startDate, endDate, grouping, interval} = this.financialStatsForm.value;


    this.filters.companyIds = this.selectedCompanies.map(value => value.id);
    this.filters.productIds = this.selectedProducts.map(value => value.id);
    this.filters.countryIsoCodes = this.selectedCountries.map(value => value.isoCode);
    this.filters.platform = this.selectedPlatform;



    // get totals
    this.isLoadingTotals = true;
    this.financialStatisticsService.getTotals(startDate, endDate, grouping, interval, this.filters).subscribe(
      (rawData) => {


        this.totals = rawData;
        this.isLoadingTotals = false;

      },
      (error) => {
        // Handle errors here
        console.error(error);
        this.isLoadingTotals = false;
      }
    );
  }

  ngOnInit() {

    registerLocaleData( de );

    this.fetchProducts();

  }

  tableOrdersData: MatTableDataSource<any>;
  tableLoadsData: MatTableDataSource<any>;
  tableLoadsVolumeData: MatTableDataSource<any>;
  displayedOrdersColumns: string[]; // Column names for the table
  displayedLoadsColumns: string[]; // Column names for the table
  displayedLoadsVolumeColumns: string[]; // Column names for the table
  companies: Company[] = [];
  displayRawOrdersValues = false;
  displayRawLoadsValues = false;

  toggleDisplayRowOrderValues() {
    this.displayRawOrdersValues = !this.displayRawOrdersValues;
  }
  toggleDisplayRowLoadsValues() {
    this.displayRawLoadsValues = !this.displayRawLoadsValues;
  }


  prepareOrdersTableData() {
    // Identify all unique age groups across all data points
    const allAgeGroups = new Set(this.chartOrdersData.flatMap(item => item.series.map(s => s.name)));

    // Initialize each data point with all age groups set to zero
    // and sort the data by date
    const dataWithAllGroups = this.chartOrdersData
      .map(item => ({
        date: item.name,
        ...Array.from(allAgeGroups).reduce((acc, group) => ({...acc, [group]: 0}), {}),
        ...item.series.reduce((acc, cur) => ({...acc, [cur.name]: cur.value}), {})
      }))
      .sort((a, b) => moment(a.date).diff(moment(b.date)));

    // Set displayed columns based on the union of all age group keys
    this.displayedOrdersColumns = ["date", ...allAgeGroups];

    this.tableOrdersData = new MatTableDataSource(dataWithAllGroups);
  }

  prepareLoadsTableData() {
    // Identify all unique age groups across all data points
    const allAgeGroups = new Set(this.chartLoadsData.flatMap(item => item.series.map(s => s.name)));

    // Initialize each data point with all age groups set to zero
    // and sort the data by date
    const dataWithAllGroups = this.chartLoadsData
      .map(item => ({
        date: item.name,
        ...Array.from(allAgeGroups).reduce((acc, group) => ({...acc, [group]: 0}), {}),
        ...item.series.reduce((acc, cur) => ({...acc, [cur.name]: cur.value}), {})
      }))
      .sort((a, b) => moment(a.date).diff(moment(b.date)));

    // Set displayed columns based on the union of all age group keys
    this.displayedLoadsColumns = ["date", ...allAgeGroups];

    this.tableLoadsData = new MatTableDataSource(dataWithAllGroups);

    // LOAD VOLUME
    const allAgeGroupsVolume = new Set(this.chartLoadsVolumeData.flatMap(item => item.series.map(s => s.name)));

    // Initialize each data point with all age groups set to zero
    // and sort the data by date
    const dataWithAllGroupsVolume = this.chartLoadsVolumeData
      .map(item => ({
        date: item.name,
        ...Array.from(allAgeGroupsVolume).reduce((acc, group) => ({...acc, [group]: 0}), {}),
        ...item.series.reduce((acc, cur) => ({...acc, [cur.name]: cur.value}), {})
      }))
      .sort((a, b) => moment(a.date).diff(moment(b.date)));

    // Set displayed columns based on the union of all age group keys
    this.displayedLoadsVolumeColumns = ["date", ...allAgeGroupsVolume];


    this.tableLoadsVolumeData = new MatTableDataSource(dataWithAllGroupsVolume);
  }



  private svg: any;
  private margin = { top: 20, right: 50, bottom: 40, left: 50 };
  private width = 800 - this.margin.left - this.margin.right;
  private height = 400 - this.margin.top - this.margin.bottom;



  private createSvg(): void {
    this.svg = d3.select("figure#stacked-bar")
      .append("svg")
      .attr("width", this.width + this.margin.left + this.margin.right)
      .attr("height", this.height + this.margin.top + this.margin.bottom)
      .append("g")
      .attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");
  }

  /*private drawChart(): void {
    const subgroups = ["value", "value2"];
    const groups = this.data.flatMap(d => d.value.map(v => v.label));
    const uniqueGroups = Array.from(new Set(groups));
    const timestamps = this.data.map(d => d.timeStamp);

    const x0 = d3.scaleBand()
      .domain(timestamps.map(d => d.toString()))
      .range([0, this.width])
      .padding(0.1);

    const x1 = d3.scaleBand()
      .domain(uniqueGroups)
      .range([0, x0.bandwidth()])
      .padding(0.05);

    const yLeftMax = d3.max(this.data.flatMap(d => d.value.map(v => v.value))) ?? 0;
    const yLeft = d3.scaleLinear()
      .domain([0, yLeftMax])
      .range([this.height, 0]);

    const yRightMax = d3.max(this.data.flatMap(d => d.value.map(v => v.value2))) ?? 0;
    const yRight = d3.scaleLinear()
      .domain([0, yRightMax])
      .range([this.height, 0]);

    const color = d3.scaleOrdinal()
      .domain(subgroups)
      .range(['#1f77b4', '#ff7f0e']);

    this.svg.append("g")
      .attr("transform", "translate(0," + this.height + ")")
      .call(d3.axisBottom(x0).tickFormat(d => new Date(+d).toLocaleDateString()).tickSize(0))
      .selectAll("text")
      .attr("transform", "rotate(-90)")
      .style("text-anchor", "end")
      .attr("dx", "-0.8em")
      .attr("dy", "-0.15em");

    this.svg.append("g")
      .call(d3.axisLeft(yLeft));

    this.svg.append("g")
      .attr("transform", "translate(" + this.width + " ,0)")
      .call(d3.axisRight(yRight));

    this.svg.append("g")
      .selectAll("g")
      .data(this.data)
      .enter().append("g")
      .attr("transform", d => `translate(${x0(d.timeStamp.toString())},0)`)
      .selectAll("rect")
      .data(d => d.value.map(v => ({ key: d.timeStamp.toString(), value: v })))
      .enter().append("rect")
      .attr("x", d => x1(d.value.label))
      .attr("y", d => yLeft(d.value.value))
      .attr("width", x1.bandwidth())
      .attr("height", d => this.height - yLeft(d.value.value))
      .attr("fill", d => color("value"));

    this.svg.append("g")
      .selectAll("g")
      .data(this.data)
      .enter().append("g")
      .attr("transform", d => `translate(${x0(d.timeStamp.toString())},0)`)
      .selectAll("rect")
      .data(d => d.value.map(v => ({ key: d.timeStamp.toString(), value: v })))
      .enter().append("rect")
      .attr("x", d => x1(d.value.label))
      .attr("y", d => yLeft(d.value.value) - (this.height - yRight(d.value.value2)))
      .attr("width", x1.bandwidth())
      .attr("height", d => this.height - yRight(d.value.value2))
      .attr("fill", d => color("value2"))
      .attr("opacity", 0.6);
  }*/


}


interface DataPoint {
  label: string;
  value: number;
  value2: number;
}

interface Data {
  timeStamp: number;
  value: DataPoint[];
}
